import { createTheme } from "@mui/material/styles";

// Freedom Power brand palette (matches the vendor portal).
export const FREEDOM_ORANGE = "#F98A3C";
export const FREEDOM_BLUE = "#252F38";

export const routingColor = {
  escalate_legal: { bg: "#FEF2F2", text: "#B91C1C", label: "Legal threat" },
  handoff_cs: { bg: "#FFFBEB", text: "#B45309", label: "Customer — hand to CS" },
  point_to_form: { bg: "#EFF6FF", text: "#1D4ED8", label: "Lead — point to form" },
  reply: { bg: "#ECFDF3", text: "#15803D", label: "Safe to reply" },
  needs_decision: { bg: "#F1F5F9", text: "#475569", label: "You decide" },
};

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: FREEDOM_ORANGE },
    secondary: { main: FREEDOM_BLUE },
    background: { default: "#F4F5F7" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"IBM Plex Sans", system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    h1: { fontFamily: '"Manrope", sans-serif', fontWeight: 800 },
    h2: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
    h6: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 }, // no SCREAM CASE on buttons
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: "none" } },
    },
    MuiTab: { styleOverrides: { root: { textTransform: "none" } } }, // no all-caps tabs
    MuiCard: { styleOverrides: { root: { border: "1px solid #E2E8F0" } } },
  },
});

export default theme;
